import React from 'react'
import {
    AnswerCardIcon,
    AnswerImageIcon,
    AnswerMiniIcon,
    AnswerTextIcon,
    AnswerFileIcon,
    AnswerVideoIcon,
} from '../../../conf/images'
import './AnswerMenu.css'
import Drawer from '../../../components/Drawer'
import Upload from '../../../components/Upload'

export type AnswerType =
    | 'text'
    | 'image'
    | 'card'
    | 'mini'
    | 'file'
    | 'video/mp4'
interface AnswerMenuProps {
    onSelect?: (type: AnswerType) => void
    isOpen?: boolean
    onClose?: () => void
    onUploaded?: (type: AnswerType, imgSrc: string, name: string) => void
}
const AnswerMenu: React.FC<AnswerMenuProps> = (props) => {
    const {
        isOpen = false,
        onSelect = () => undefined,
        onClose,
        onUploaded,
    } = props
    const AnswerItem = ({
        icon,
        label,
        type,
        lt = 50,
    }: {
        icon: string
        label: string
        type: AnswerType
        lt?: number
    }) => {
        if (type === 'image' || type === 'file' || type === 'video/mp4') {
            return (
                <div className='answer-menu-item'>
                    <Upload
                        acceptType={type}
                        lt={lt}
                        onResolve={(src, name) => {
                            onUploaded && onUploaded(type, src, name)
                            onClose && onClose()
                        }}
                    >
                        <img className='answer-icon' src={icon} alt={label} />
                    </Upload>
                    <p className='answer-type'>{label}</p>
                </div>
            )
        }
        return (
            <div className='answer-menu-item' onClick={() => onSelect(type)}>
                <img className='answer-icon' src={icon} alt={label} />
                <p className='answer-type'>{label}</p>
            </div>
        )
    }
    return (
        <Drawer isOpen={isOpen} placement='bottom' onClose={onClose}>
            <div className='answer-menu'>
                <p className='menu-title'>请选择答案类型</p>
                <div className='menu-content'>
                    <div className='menus'>
                        <AnswerItem
                            type='text'
                            icon={AnswerTextIcon}
                            label='文本'
                        />
                        <AnswerItem
                            type='image'
                            icon={AnswerImageIcon}
                            label='相册'
                        />
                        <AnswerItem
                            type='card'
                            icon={AnswerCardIcon}
                            label='卡片'
                        />
                        <AnswerItem
                            type='mini'
                            icon={AnswerMiniIcon}
                            label='小程序'
                        />
                        <AnswerItem
                            type='file'
                            icon={AnswerFileIcon}
                            label='文件'
                        />
                        <AnswerItem
                            type='video/mp4'
                            icon={AnswerVideoIcon}
                            label='视频'
                        />
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default AnswerMenu
